import {KeycloakService} from "keycloak-angular";
import {ApplicationSettings} from "@supoui/shared/model/application.settings";

export async function initializeKeycloak(keycloak: KeycloakService, settings: ApplicationSettings): Promise<boolean> {
  return keycloak.init({
    config: {
      url: settings.keycloak.authority,
      realm: settings.keycloak.realm,
      clientId: settings.keycloak.clientId,
    },
    loadUserProfileAtStartUp: true,
    initOptions: {
      onLoad: 'check-sso',
      silentCheckSsoRedirectUri: window.location.origin + '/assets/silent-check-sso.html',
      checkLoginIframe: false,
    },
  });
}
